// extracted by mini-css-extract-plugin
export default {"container":"EditUser_container__MfNIz","error__text":"EditUser_error__text__7yJgt"};